module.exports = __webpack_public_path__ + "static/img/12.577d7dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/12.png
// module id = +tvB
// module chunks = 0